import { configureRequest } from "@asosteam/asos-web-request";
import packageInfo from "../package.json";
const { name, version } = packageInfo;
const getConfiguredRequest = (logger) => configureRequest({
    defaultTimeout: 5000,
    logger,
    client: {
        name,
        version,
    },
});
export default getConfiguredRequest;
